<template>
  <div class="brandCenter">
    <!--<topfixed></topfixed>-->
    <div class="company-main">
      <div class="company-top">
        <div class="company-text" >
          <h1>公司简介</h1>
          <img class="xian">
          <p mode="wrap">中智游(北京)科技有限公司（2016年4月由北京巅峰智慧旅游科技有限公司更名）是中国智慧旅游领军企业，致力于利用先进的技术和互联网理念，推动中国“旅游+”与 “互联网+”的融合发展.公司业务包括“智慧旅游规划与顾问+智慧旅游研发与建设+智慧旅游投资与运营+目的地智慧营销”四大业务板块，为旅游主管部门、景区、涉旅企业提供包括智慧旅游规划与设计，智慧旅游系统研发与建设，智慧旅游平台投资与运营、旅游目的地智慧运营、旅游目的地智慧营销等全程智慧旅游服务。</p>
        </div>

      </div>
      <div class="company-aboutUs">
        <h2 class="us">关于我们  <span> ABOUT US</span> </h2>
        <P mode="wrap" class='letter'>公司首席架构师由国内知名旅游专家、国家智慧旅游顾问蒋骏担任。作为中国智慧旅游产业联盟秘书长、微软公司认证高级架构设计师，蒋骏兼任多家旅游地产集团(绿城中国(03900.HK)、大港旺宝等)战略管理顾问。主持编写《北京市智慧景区建设规范》、《天津市智慧景区建设规范》，是多个城市智慧旅游顾问。曾任用友软件集团助理总裁，具有15年流程再造和信息化实施经验，负责过多项大型工业园区及智慧旅游营运服务项目，具备专业的智慧旅游建设能力及丰富的智慧旅游全程服务经验。</P>

      </div>
      <div class="company-boss">
        <img src="../../assets/images/person.jpg" width="40%" height="100%" style="float:left; margin-right:0.2rem">
        <h2 class="us">集团高管  <span> EXECUTIVES</span> </h2>
        <P class='letter' >蒋骏先生现任：中智游集团首席架构师、中国智慧旅游产业联盟秘书长、中国信息协会电子政务专业委员会专家委员、北京市旅游信息化专家咨询委会专家委员、中国房地产业协会经营管理专业委员会副主任、国家智慧旅游公共服务平台高级顾问、绿城中国(03900.HK)特聘管理顾问、中国科学院工学硕士、中欧国际工商学院EMBA、清华大学工学/法学双学士、微软公司认证高级架构设计师。</P>
      </div>

      <div class="company-contactUs clearfix" >
        <h2 class="us">联系我们  <span>CONTACT US</span></h2>

        <div class="picture clearfix" style="position: relative">
          <div class="address">
            <h3>中智游(北京)科技有限公司</h3>
            <h4>地址：北京市朝阳区管庄周家井新华世通中心C座406</h4>
            <img class="tel" src="http://qiniu.image.citgroup.cn/citgroup%2Fm%2F202002210008.png" width="60%" height="100%" >
          </div>
          <img class="ditu " id="imgTest" src="https://qiniu.image.citgroup.cn/citgroup/m/20241118150530.png" width="60%" height="100%" >

          <img id = "AnimaitImg" src="https://qiniu.image.citgroup.cn/citgroup/m/20241118150530.png" />

        </div>

      </div>
      <div class="company-research clearfix">
        <div class="address">
          <h2 class="us" >成都公司</h2>
          <h4>地址：成都市锦江区梓潼桥正街25号附一号西部文化产业中心7层</h4>
          <h4><a href="tel:4008396360">联系电话：400 839 6360</a></h4>
        </div>
        <img class="building" src="../../assets/images/building.png" width="50%" height="100%" >
      </div>
      <div class="company-research clearfix">
        <div class="address">
          <h2 class="us" >云南公司</h2>
          <h4>地址：云南省昆明市西山区日新中路397号广福城写字楼A11-B2幢onework2层210</h4>
          <h4><a href="tel:4008396360">联系电话：400 839 6360</a></h4>
        </div>
        <img class="building" src="http://qiniu.image.citgroup.cn/citgroup/m/202002210003.png" width="50%" height="100%" >
      </div>

      <div style="height:1.2rem"></div>
    </div>
  </div>
</template>

<script>
//import topfixed from '../topfixed'
  import MintUI from 'mint-ui'
export default {
  name: 'brandCenter',
  data () {
    return {
      msg: ''
    }
  },
  components:{
//  topfixed:topfixed
  }
}
</script>

<style scoped>
  .topfixed-wrap{
    background: #010101!important;
  }
  /*company-top*/
  .company-top {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .company-top img.bg-big{
    display: block;
    height:100%;
    width:100%;
    left:0;
    right:0;
  }
  .company-text{
    width:98%;
    font-size: 0.24rem;
    margin: 0 auto;
    padding: 0.8rem 0rem;
  }
  .company-text h1{
    font:400 0.26rem microsoft Yahei;
    color:#fff;
    margin-bottom: 0px;
  }
  .company-text img.xian{
    width:3rem;
    border-bottom:2px solid #fff;
    margin-bottom: 0.1rem;
  }
  .company-text p{
    font-size: 0.2rem;
    text-indent: 2em;
    font-family: "micsoft yahei";
    color: #fff;
    text-align: left;
    line-height: 0.3rem;
    padding: 0.05rem 0.3rem;
    text-align: justify;
  }

  /*about us*/
  .company-aboutUs{
    padding: 0.2rem 0.3rem;
  }
.company-aboutUs .us{
  font-size:0.23rem;
  color: #030303;
  background: #bbbbbb;
  padding: 0.15rem 0;
  text-align: center;
  width: 45%;
}
.company-aboutUs span{
  font-size: 0.16rem;
}
p.letter{
  font-size: 0.2rem;
  text-align: left;
  line-height: 0.32rem;
  text-indent: 2em;
  padding-top: 0.2rem;
}
/*集团高管*/
  .company-boss{
    padding: 0.2rem 0.3rem;
  }
  .company-boss .us{
    font-size:0.24rem;
    color: #030303;
    background: #bbbbbb;
    padding: 0.15rem 0;
    text-align: center;
    width: 50%;
    float: right;
    margin-right: 5%;
    margin-bottom: 0.2rem;
  }
  .company-boss span{
    font-size: 0.16rem;
  }
  /*联系我们*/
  .company-contactUs{
    padding: 0.2rem 0.3rem;
  }
  .company-contactUs .us{
    font-size:0.24rem;
    color: #030303;
    background: #bbbbbb;
    padding: 0.15rem 0;
    text-align: center;
    width: 50%;
    margin-bottom: 0.2rem;
  }
  .company-contactUs span{
    font-size: 0.16rem;
  }
  .address h3{
    font-size: 0.21rem;
    padding: 0.08rem 0;
  }
  .address h4{
    font-size: 0.16rem;
    padding: 0.08rem 0;
  }
  .address img{
    margin: 0.15rem 0;
  }
  /*成都*/
  .company-research{
    padding: 0.2rem 0.3rem;
  }
  .company-research .us{
    font-size:0.24rem;
    color: #030303;
    background: #bbbbbb;
    padding: 0.15rem 0;
    text-align: center;
    width: 50%;
    margin-bottom: 0.2rem;
  }

  .company-main{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #ededed;
    margin-top: 0.45rem;
  }
.company-top{
  background-image:url("../../assets/images/computer.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0

}
  #AnimaitImg{
    transition:all 0.3s ease;
    cursor:pointer;
    position:absolute;
    right:15px;
    bottom:40px;
    z-index:10001;
    width:0%;
  }


</style>



// WEBPACK FOOTER //
// src/components/brandCenter/brandCenter.vue